module.exports = __webpack_public_path__ + "media/images/vcard-a6f6005892939c4271a3542f791966d1.png";